import Swal from 'sweetalert2';

export type NotificationStatus = 'success' | 'error' | 'warning' | 'info';

interface NotificationOptions {
  title: string;
  message: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  timer?: number;
}

export const useNotification = () => {
  const showNotification = (
    status: NotificationStatus,
    options: NotificationOptions
  ) => {
    const colors = {
      success: '#16a34a',
      error: '#dc3545',
      warning: '#d97706',
      info: '#0ea5e9'
    };

    const swalConfig: any = {
      title: options.title,
      text: options.message,
      icon: status,
      confirmButtonText: options.confirmButtonText || 'OK',
      confirmButtonColor: colors[status],
      showCancelButton: !!options.onCancel,
      cancelButtonText: options.cancelButtonText || 'Cancel',
    };

    // Auto-close for success/info messages
    if (options.timer) {
      swalConfig.timer = options.timer;
      swalConfig.timerProgressBar = true;
    }

    return Swal.fire(swalConfig).then((result) => {
      if (result.isConfirmed && options.onConfirm) {
        options.onConfirm();
      } else if (result.isDismissed && options.onCancel) {
        options.onCancel();
      }
      return result;
    });
  };

  return { showNotification };
};